import React from 'react';

import classnames from 'classnames';

import { GridStyleLayout, WithLoading } from 'common/components';

const ProductFullLayout = (props) => {
  const { className = [], loading, children } = props;

  return (
    <GridStyleLayout
      className={classnames(['product-full-view', ...className])}
      areas={[
        ['primary', 'right'],
        ['divider', 'right'],
        ['content', 'right'],
      ]}
      rows='auto auto 1fr'
      columns='1fr 1fr'
    >
      {loading ? (
        <WithLoading className='product-full-view__loading' loading />
      ) : (
        children
      )}
    </GridStyleLayout>
  );
};

export default ProductFullLayout;
